﻿import {JsonFetchJson} from "../../Helper/FetchHelper";
import {ResponseApi} from "../../Model/ResponseApi";
import {OnTemplateAdd} from "../../Delegates/TemplateDelegate";
import {TypeContentEnum} from "../../Variables/TypeContentEnum";
import {ITemplateModel} from "../../Model/Template/ITemplateModel";

export class TemplateCreateController {
    public static Create = async (fkProjet: string) => {
        return JsonFetchJson.Get<ResponseApi<ITemplateModel>>(`/template/create/${fkProjet}`)
            .then(response => {
                response.Data.TypeContentLibelle = TypeContentEnum.Instance.GetLibelle(response.Data.TypeContent);
                response.Data.TypeProcessLibelle = TypeContentEnum.Instance.GetLibelle(response.Data.TypeProcess);
                response.Data.BodyTemplate = "Template de contenu {{ici}}";
                response.Data.SubjectTemplate = "";
                response.Data.Datas[0].Code = "{\"ici\":\"Valeur\"}";
                OnTemplateAdd.Fire(response.Data);
                return response.Data;
            });
    }
}